<template>
  <div>
    <!-- Categories -->
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <button :style="setColor('A')" class="btn btn-sm text-sx" @click="filterFlagChanged('A')">All</button>
        <div>|</div>
        <button :style="setColor('P')" class="btn btn-sm text-sx" @click="filterFlagChanged('P')">Published</button>
        <div>|</div>
        <button :style="setColor('D')" class="btn btn-sm text-sx" @click="filterFlagChanged('D')">Draft</button>
        <div>|</div>
        <button :style="setColor('T')" class="btn btn-sm text-sx " @click="filterFlagChanged('T')">Trash</button>
      </div>

    </div>
    <!-- filters -->
    <div class="d-flex my-2">
      <div class="d-flex flex-row">
        <select v-model="selectedDate" class="py-2 border border-secondary rounded px-2 me-2" @change="selectDate">
          <option :value=null>All Dates</option>
          <option v-for="(monthInfo, index) in months" :key="index" :value="monthInfo">
            {{ monthInfo.month_name }} {{ monthInfo.year_value }}
          </option>
        </select>
        <select v-model="selectedSubCategoryInfo" class="py-2 border border-secondary rounded px-2 me-2"
                @change="selectSubCategory">
          <option :value=null>All Categories</option>
          <option v-for="(info, index) in categories" :key="index" :value="info">{{
              info.name
            }}
          </option>
        </select>
        <button class="btn btn-secondary" @click="clearFilter">
          Clear Filters
        </button>
      </div>
    </div>

    <!-- table  -->
    <!--    <div v-if="loading" class="d-flex justify-content-center">-->
    <!--      <div class="spinner-border mt-4" role="status">-->
    <!--        <span class="visually-hidden">Loading...</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <div>
      <h5 class="">{{ tableHeading }}</h5>
      <!--        Filter        -->
      <b-row>
        <b-col class="my-2 col-4 p-1" lg="3" md="4">
          <b-form-group class="mb-0 ms-2">
            <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" class="col-md-4" size="sm"
                           @change="handlePageSizeChange"></b-form-select>
          </b-form-group>
        </b-col>
        <!--        search        -->
        <b-col class="my-2 col-4" lg="6" md="4"></b-col>
        <b-col class="my-2 col-4 p-1" lg="3" md="4">
          <div class="d-flex flex-row align-items-center">
            <b-input-group class="me-2" size="sm">
              <b-form-input id="filter-input" v-model="filter" placeholder="Type to Search"
                            type="search"></b-form-input>
            </b-input-group>
            <button class="rounded btn-info me-4" @click="onFiltered">Search</button>
          </div>

        </b-col>
      </b-row>
      <b-table :busy="loading" :fields="fields" :items="allPosts" bordered hover striped>
        <template #table-busy>
          <div class="text-center text-danger my-2 px-2">
            <b-spinner class="align-middle mx-2"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template #cell(custom_public_yn)="row">

          <span v-if="row.item.public_yn == 'Published'" class="badge bg-success"> {{
              row.item.public_yn
            }}</span>
          <span v-else class="badge" style="background-color: rgb(82, 11, 141)"> {{
              row.item.public_yn
            }}</span>
        </template>

        <template #cell(title)="row">
          <div v-if="row.item.title.length > 150">{{ row.item.title.slice(0, 149) }} ...</div>
          <div v-else style="display: flex; flex-direction: column;">
            {{ row.item.title }}
          </div>
          <div style="min-height: 25px; height: fit-content">
            <div v-if="permissions.UPDATE_CONTENT == 'Y' || permissions.DELETE_CONTENT == 'Y'" class="hover-btn mt-1">
              <span v-if="permissions.UPDATE_CONTENT == 'Y'" class="me-2">
                <a v-if="filter_flag == 'T'" class="" href="javascript:void(0)" @click="revertElement(row.item.id)">
                  <i class="fa-solid fa-clock-rotate-left text-black" style="font-size: 14px"></i> Revert
                </a>
                <router-link v-else :to="'/' + editLink + '/edit/' + row.item.id">
                  <a class="" href="javascript:void(0)">
                    <i class="fa-regular fa-pen-to-square text-primary"></i> Edit
                  </a>
                </router-link>
              </span>
              <span v-if="permissions.DELETE_CONTENT == 'Y'">
                <a v-if="filter_flag == 'T'" class="ms-2 text-danger" href="javascript:void(0)"
                   @click="permanentlyDeleteElement(row.item.id)">
                  <i class="fa-solid fa-eraser text-danger"></i> Delete
                </a>
                <a v-else class="text-danger" href="javascript:void(0)" @click="deletePost(row.item.id)">
                  <i class="fa-solid fa-eraser text-danger "></i> Delete
                </a>
              </span>
            </div>
          </div>
        </template>
      </b-table>
      <!--    Pagination            -->
      <b-row>
        <b-col class="mt-2" md="12" sm="12">
          <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" align="center" class="my-0"
                        next-text="Next" prev-text="Prev" @click="handlePageChange"></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {notify} from "@kyvg/vue3-notification";
import postService from '@/services/post.service';
import subcategoryService from '@/services/subCategory.service';
import moment from 'moment';

export default {
  setup() {
  },
  props: ['category_id', 'editLink'],
  data() {
    return {
      fields: [
        {
          key: 'title', sortable: true, thStyle: {width: "22%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'title_en', label: 'English Title', sortable: false,
          thStyle: {width: "22%"},
          tdClass: "px-3", thClass: "px-3",
          formatter: (value) => {
            if (value !== null && value.length > 150) {
              return value.slice(0, 149) + "...";
            } else {
              return value;
            }
          },
        },
        {
          key: 'subcategory_name', label: 'Categories', sortable: false,
          thStyle: {width: "21%"}, tdClass: "px-3", thClass: "px-3",

        },
        {key: 'publish_time', sortable: true, class: 'text-center'},
        {key: 'expiry_time', sortable: true, class: 'text-center'},
        {
          key: 'custom_public_yn', label: 'Status', class: 'text-center',
          thStyle: {width: "8%"},
        },
        {
          key: 'insert_by_name', label: 'Created By', tdClass: "px-2", thClass: "px-2",
        },

      ],
      allPosts: [],
      loading: false,
      totalRows: 1,
      currentPage: 1,
      filter_flag: 'A', // A, P, D, T
      perPage: 10,
      pageOptions: [5, 10, 100],
      sortBy: '',
      sortDesc: true,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      userInfo: null,
      index: null,
      to: null,
      prevFilter: null,
      selectedSubCategoryInfo: null,
      selectedSubCategoryId: null,
      selectedSubCategoryName: null,
      selectedDate: null,
      categories: [],
      months: [],
      permissions: {},
    };
  },
  created() {
    this.permissions = JSON.parse(localStorage.getItem("permissions"));
    this.getPostsByCategory();
    this.getCategories();
    this.getMonths();
  },
  watch: {
    filter(data) {
      if (this.prevFilter != data) {
        this.currentPage = 1
        this.getPostsByCategory();
        this.prevFilter = data
      }
      return data;
    }
  },
  methods: {
    getMonths() {
      const today = new Date();
      const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      let month = today.getMonth();
      let year = today.getFullYear();

      for (let index = 0; index < 12; index++) {
        this.months.push(
            {
              'month_name': monthNames[month],
              'month_value': month,
              'year_value': year,
            }
        );
        if (month - 1 < 0) {
          month = 11;
          year = year - 1;
        } else {
          month--;
        }
      }
    },
    async clearFilter() {
      this.currentPage = 1;
      this.filter_flag = 'A';
      this.perPage = 10;
      this.sortBy = '';
      this.sortDesc = true;
      this.sortDirection = 'asc';

      this.selectedSubCategoryInfo = null;
      this.selectedSubCategoryId = null;
      this.selectedSubCategoryName = null;
      this.selectedDate = null;

      this.filter = null;
      this.prevFilter = null;
      await this.getPostsByCategory();
    },
    async selectSubCategory() {
      if (this.selectedSubCategoryInfo != null) {
        this.selectedSubCategoryName = this.selectedSubCategoryInfo.name;
        this.selectedSubCategoryId = this.selectedSubCategoryInfo.id;
      } else {
        this.selectedSubCategoryName = null;
        this.selectedSubCategoryId = null;
      }
      this.currentPage = 1;
      await this.getPostsByCategory();
    },
    async selectDate() {
      this.currentPage = 1;
      await this.getPostsByCategory();
    },
    onFiltered() {
      if (this.prevFilter != this.filter) {
        this.currentPage = 1
        this.getPostsByCategory();
        this.prevFilter = this.filter
      }
    },
    onSorted() {
      this.currentPage = 1
      this.getPostsByCategory();
    },
    async handlePageChange() {
      await this.getPostsByCategory();
    },
    handlePageSizeChange(value) {
      this.perPage = value;
      this.currentPage = 1;
      this.getPostsByCategory();
    },
    checkAll() {
      const table = document.querySelector("table");
      const tableHeadCheckbox = table.querySelector("thead input[type=checkbox]");
      const tableBodyCheckbox = table.querySelectorAll("tbody input[type=checkbox]");
      tableBodyCheckbox.forEach((checkbox) => {
        checkbox.checked = tableHeadCheckbox.checked;
      });
    },

    async filterFlagChanged(filter_flag) {
      this.currentPage = 1;

      if (filter_flag != null) {
        this.filter_flag = filter_flag;
        this.getPostsByCategory();
      } else {
        this.filter_flag = "A";
        this.getPostsByCategory();
      }
    },
    async getCategories() {
      this.loading = true;
      const response = await subcategoryService.getSubCategoriesByCategoryId(this.category_id);
      this.loading = false;
      if (response.data) {
        this.categories = response.data;
      }
    },
    async getPostsByCategory() {
      this.loading = true;
      // await new Promise(resolve => setTimeout(resolve, 5000));
      const params = {
        'per_page': this.perPage,
        'page': this.currentPage,
        'sort_by': this.sortBy,
        'sort_type': (this.sortDesc) ? 'desc' : 'asc',
        'search': this.filter,
        'filterFlag': this.filter_flag,
      };
      if (this.selectedSubCategoryId != null) {
        params['subCatId'] = this.selectedSubCategoryId;
      }
      if (this.selectedDate != null) {
        params['pDate'] = String(this.selectedDate.month_value + 1).padStart(2, '0') + '-' + String(this.selectedDate.year_value);
      }

      var response;
      try {
        response = await postService.getPaginatedPostsByCategoryId(this.category_id, params);
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Delete Post",
          text: error.response.data.message,
        });
      }

      this.loading = false;

      if (response.data) {
        this.allPosts = response.data.data.data;
        this.currentPage = response.data.data.current_page;
        this.totalRows = response.data.data.total;
        this.perPage = response.data.data.per_page;
        this.to = response.data.data.to;
        for (let index = 0; index < this.allPosts.length; index++) {
          if (this.allPosts[index].public_yn == 'Y') {
            this.allPosts[index].public_yn = 'Published';
          } else {
            this.allPosts[index].public_yn = 'Draft';
          }
          if (this.allPosts[index].publish_time != null) {
            this.allPosts[index].publish_time = this.format_date(this.allPosts[index].publish_time);
          }
          if (this.allPosts[index].expiry_time != null) {
            this.allPosts[index].expiry_time = this.format_date(this.allPosts[index].expiry_time);
          }
          var subcategories = "";
          // for (let index2 = 0; index2 < this.allPosts[index].subCategoryNames.length; index2++) {
          //     if (index2 == 0) {
          //         subcategories = this.allPosts[index].subCategoryNames[index2];
          //     } else {
          //         subcategories = subcategories + ", " + this.allPosts[index].subCategoryNames[index2];
          //     }
          // }
          this.allPosts[index].categoryFront = subcategories;
        }
      }
    },

    async deletePost(id) {
      this.loading = true;
      const response = await postService.deletePost(id);
      this.loading = false;
      if (response.data) {
        if (response.data['messageCode'] == 1) {
          notify({
            type: "success",
            title: "Delete Post",
            text: response.data.message,
          });
          this.getPostsByCategory();
        } else {
          notify({
            type: "error",
            title: "Delete Post",
            text: response.data.message,
          });
        }
      }
    },

    async permanentlyDeleteElement(id) {
      //this.loading = true;
      // if (this.permissions.DELETE_CONTENT == "N") {

      //  }
      const result = await this.$swal({
        title: 'Are you sure, You want to Delete this Content?',
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#dd3333',
        showConfirmButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#007bff',
      });
      if (result.isConfirmed) {
        const response = await postService.permanentDeleteEle(id);
        //this.loading = false;
        if (response.data) {
          if (response.data['messageCode'] == 1) {
            notify({
              type: "success",
              title: "Delete Post",
              text: response.data.message,
            });
            this.getPostsByCategory();
          } else {
            notify({
              type: "error",
              title: "Delete Post",
              text: response.data.message,
            });
          }
        } else {
          //this.loading = false;
        }
      }


      /*this.loading = true;
      const response = await postService.deletePost(id);
      this.loading = false;
      if (response.data) {
          if (response.data['messageCode'] == 1) {
              notify({
                  type: "success",
                  title: "Delete Post",
                  text: response.data.message,
              });
              this.getPostsByCategory();
          } else {
              notify({
                  type: "error",
                  title: "Delete Post",
                  text: response.data.message,
              });
          }
      }*/
    },
    async revertElement(id) {
      this.loading = true;
      const response = await postService.revertPost(id);
      this.loading = false;
      if (response.data) {
        if (response.data['messageCode'] == 1) {
          notify({
            type: "success",
            title: "Delete Post",
            text: response.data.message,
          });
          this.getPostsByCategory();
        } else {
          notify({
            type: "error",
            title: "Delete Post",
            text: response.data.message,
          });
        }
      }
    },

    format_date(value) {
      if (value) {
        return moment(String(value)).format('DD MMM, YYYY')
      }
    },
    setColor(filter_flag) {
      if (this.filter_flag == filter_flag) {
        this.isColor = 'grey';
      } else {
        this.isColor = 'blue';
      }
      return {color: this.isColor};
    }
  },
};
</script>

<style>
.table-data-style {
  padding-block: 10px;
}

.table td {
  padding-bottom: 15px !important;
}
</style>
